module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "drop": function($event) {
        $event.stopPropagation();
        return _vm.drop($event)
      }
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.label,
      "multi-line": "",
      "rules": _vm.rules,
      "required": _vm.required
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center"
  }, [_c('input', {
    ref: "file",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.fileChanged
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6cc82b37","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PublicKeyInput.vue
// module id = 1079
// module chunks = 1